import reportAnalyticApi from '../../api/reportAnalyticApi';

export const getExportWip = (filters) => {
    return reportAnalyticApi.getExportWip(filters);
}
